export default {
  pay_popup: {
    card_pay: '支持信用卡和扣賬卡/金融卡/借記卡',
    card_pay_des: '可透過stripe客戶門戶的「設置」來取消或管理您的訂閲'
  }
}
